// extracted by mini-css-extract-plugin
export default {"groupList":"style_groupList__5EOSO","groups":"style_groups__s7Vy1","userTable":"style_userTable__qfkM0"};